import Modal, { ModalOwnProps } from '@mui/material/Modal';
import { MouseEvent } from 'react';

export type ModalSize = 'xsmall' | 'small' | 'medium' | 'large';
export type ModalOwnPropsOverrides = ModalOwnProps & {
	externalClickClose?: boolean;
	size?: ModalSize;
};

const sizeMap = {
	xsmall: 'w-[90vw] xl:w-4/12 2xl:w-4/12',
	small: 'w-[90vw] xl:w-4/12 2xl:w-6/12',
	medium: 'w-[90vw] xl:w-8/12',
	large: 'w-[90vw] xl:w-10/12',
};

export default function PopupDefault({
	children,
	open,
	size = 'medium',
	onClose,
	externalClickClose = true,
	classes = { root: 'outline-0', backdrop: 'bg-black/30' },
	...props
}: ModalOwnPropsOverrides) {
	const handleExternalClick = (e: MouseEvent<unknown>, reason: 'backdropClick' | 'escapeKeyDown') => {
		if (externalClickClose && onClose) onClose(e, reason);
	};

	return (
		<Modal open={open} onClose={handleExternalClick} classes={classes} {...props}>
			<section
				className={`${sizeMap[size]} absolute top-3 left-1/2 transform -translate-x-1/2 p-7 max-h-screen rounded-2xl shadow-md bg-white outline-0`}
			>
				{children as React.ReactElement}
			</section>
		</Modal>
	);
}
